<template>
  <div class="grid gap-4 mb-6" :class="gridCols">
    <div v-for="(card, index) in cards" :key="index" class="border border-gray-200 rounded-xl p-5 bg-white">
      <span
        v-if="card.badge"
        class="inline-block px-3 py-1 text-xs font-bold tracking-wider rounded-full uppercase mb-3"
        :class="badgeClasses(card.badgeColor)"
      >
        {{ card.badge }}
      </span>
      <h3 class="text-lg font-semibold text-gray-900 mb-3">{{ card.title }}</h3>
      <ul class="space-y-2 mb-3">
        <li v-for="(item, i) in card.items" :key="i" class="flex items-start gap-2">
          <span class="text-primary-500 mt-0.5">&#8226;</span>
          <MarkdownText :content="item" class="text-sm text-gray-700 inline" />
        </li>
      </ul>
      <p v-if="card.note" class="text-xs text-gray-500 italic border-t border-gray-100 pt-3">
        {{ card.note }}
      </p>
    </div>
  </div>
</template>

<script>
import { MarkdownText } from "@estaly/ui";

export default {
  name: "ComparisonCards",
  components: { MarkdownText },
  props: {
    cards: { type: Array, required: true },
  },
  computed: {
    gridCols() {
      if (this.cards.length === 1) return "grid-cols-1";
      if (this.cards.length === 2) return "grid-cols-1 md:grid-cols-2";
      return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3";
    },
  },
  methods: {
    badgeClasses(color) {
      const colors = {
        green: "text-green-700 bg-green-50 border border-green-200",
        blue: "text-blue-700 bg-blue-50 border border-blue-200",
        purple: "text-purple-700 bg-purple-50 border border-purple-200",
        orange: "text-orange-700 bg-orange-50 border border-orange-200",
        red: "text-red-700 bg-red-50 border border-red-200",
        dark: "text-gray-100 bg-gray-700 border border-gray-600",
        olive: "text-yellow-800 bg-yellow-50 border border-yellow-200",
      };
      return colors[color] || "text-gray-700 bg-gray-50 border border-gray-200";
    },
  },
};
</script>
